import { useState } from "react";
import {
  ExternalContainer,
  InternalContainer,
} from "../../../../components/Reusable/Layout";
import { DataPlansTable, DataPlanSearchFilter } from "./component";
import { CreateDataModal } from "../../Modal/Data/CreateDataModal";
import { Product } from "../../../../components/Reusable/type";
import { DataPlan } from "./types";
import { EditDataModal } from "../../Modal/Data/EditDataModal";
import { DeleteDataModal } from "../../Modal/Data/DeleteDataModal";

interface DataPlansProps {
  dataPlans: Product[];
  loading?: boolean;
  error?: string | null;
  statusFilter: string;
  setStatusFilter: (status: string) => void;
  onDataPlanClick: (dataPlan: Product) => void;
  searchTerm: string;
  setSearchTerm: (val: string) => void;
}

const DataPlans: React.FC<DataPlansProps> = ({
  dataPlans,
  loading,
  error,
  statusFilter,
  setStatusFilter,
  onDataPlanClick,
  searchTerm,
  setSearchTerm,
}) => {
  const [isCreateModalOpen, setIsCreateModalOpen] = useState(false);
  const [isDeleteModalOpen, setIsDeleteModalOpen] = useState(false);
  const [isEditModalOpen, setIsEditModalOpen] = useState(false);
  const [selectedDataPlan, setSelectedDataPlan] = useState<
    undefined | DataPlan
  >(undefined);
  const [dataPlanId, setDataPlanId] = useState<number | null>(null);

  const onEditClick = (data: DataPlan) => {
    setSelectedDataPlan(data);
    setIsEditModalOpen(true);
  };

  const onDeleteClick = (id: number) => {
    setDataPlanId(id);
    setIsDeleteModalOpen(true);
  };

  return (
    <ExternalContainer>
      <div className="h-screen dark:bg-[#FFFFFF1A] w-[1030px]">
        <InternalContainer headerText="Data Plans">
          <div className="flex flex-col">
            <DataPlanSearchFilter
              onStatusFilter={setStatusFilter}
              searchTerm={searchTerm}
              onSearchChange={setSearchTerm}
              onCreateNewProduct={(type) => {
                setIsCreateModalOpen(true);
              }}
            />
            <div className="border border-[#FFFFFF1A]">
              <DataPlansTable
                dataPlans={dataPlans as DataPlan[]}
                statusFilter={statusFilter}
                onDataPlanClick={onDataPlanClick}
                onEditClick={onEditClick}
                onDeleteClick={onDeleteClick}
                loading={loading}
              />
            </div>
          </div>
        </InternalContainer>
        <CreateDataModal
          isOpen={isCreateModalOpen}
          onClose={() => setIsCreateModalOpen(false)}
        />
        <EditDataModal
          dataPlan={selectedDataPlan}
          isOpen={isEditModalOpen && selectedDataPlan !== undefined}
          onClose={() => {
            setIsEditModalOpen(false);
            setSelectedDataPlan(undefined);
          }}
        />
        <DeleteDataModal
          id={dataPlanId}
          isOpen={isDeleteModalOpen && dataPlanId !== null}
          onClose={() => {
            setIsDeleteModalOpen(false);
            setDataPlanId(null);
          }}
        />
      </div>
    </ExternalContainer>
  );
};

export default DataPlans;
